<template>
    <div class="bg-gray-900 rounded-lg p-10">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div class="space-y-1">
                <label for="name" class="text-white font-bold">Meno</label>
                <input type="text" v-model="form.name" id="name" class="w-full p-2 border-2 rounded-lg text-sm" :class="[ errors.includes('name') ? 'border-red' : 'border-grey-200' ]" placeholder="Zadajte svoje meno">
            </div>

            <div class="space-y-1">
                <label for="company_name" class="text-white font-bold">Firma</label>
                <input type="text" v-model="form.company_name" id="company_name" class="w-full p-2 border-2 rounded-lg text-sm" :class="[ errors.includes('company_name') ? 'border-red' : 'border-grey-200' ]" placeholder="Zadajte názov firmy">
            </div>

            <div class="space-y-1">
                <label for="phone" class="text-white font-bold">Mobil</label>
                <input type="text" v-model="form.phone" id="phone" class="w-full p-2 border-2 rounded-lg text-sm" :class="[ errors.includes('phone') ? 'border-red' : 'border-grey-200' ]" placeholder="Zadajte svoj mobil">
            </div>

            <div class="space-y-1">
                <label for="email" class="text-white font-bold">Email</label>
                <input type="text" v-model="form.email" id="email" class="w-full p-2 border-2 rounded-lg text-sm" :class="[ errors.includes('email') ? 'border-red' : 'border-grey-200' ]" placeholder="Zadajte svoj email">
            </div>

            <div class="space-y-1">
                <label for="interest" class="text-white font-bold">Zaujímam sa o</label>
                <select id="interest" v-model="form.interest" class="w-full p-2 border-2 rounded-lg text-sm" :class="[ errors.includes('interest') ? 'border-red' : 'border-grey-200' ]">
                    <option value="Kancelárska tlač">Kancelárska tlač</option>
                    <option value="Skenery">Skenery</option>
                    <option value="Veľkoformátové zariadenia">Veľkoformátové zariadenia</option>
                    <option value="Produkčná tlač">Produkčná tlač</option>
                    <option value="Softvérové riešenia">Softvérové riešenia</option>
                </select>
            </div>

            <div class="space-y-1">
                <label for="term" class="text-white font-bold">Termín</label>
                <date-picker v-model="form.term" :lang="datePickerLang" :disabled-date="disablePastDates" format="DD.MM.YYYY" value-type="format" :input-attr="{ class: 'w-full p-2 border-2 rounded-lg text-sm' }" placeholder="Vyberte termín"/>
            </div>
        </div>

        <div class="flex mt-6">
            <div class="flex space-x-2 items-center">
                <input type="checkbox" id="agree" v-model="form.agree" name="agree" value="1" />
                <label for="agree" class="font-bold" :class="[ errors.includes('agree') ? 'text-red' : 'text-white' ]">Súhlasím so spracovaním osobných údajov</label>
            </div>
        </div>

        <div class="mt-6 flex">
            <button class="bg-green-light hover:bg-green-dark transition-colors text-white font-extrabold py-2 px-8 rounded-full w-full" @click="send">
                <span v-if="!posted && !loading">
                    Odoslať požiadavku na nezáväzné stretnutie
                </span>

                <span v-if="!posted && loading">
                    <i class="fas fa-spinner fa-spin"></i>
                </span>

                <span v-if="posted && !loading">
                    Požiadavka bola odoslaná
                </span>
            </button>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    name: 'ContactForm',
    props: ['months'],
    components: {DatePicker},
    data() {
        return {
            errors: [],
            loading: false,
            posted: false,
            form: {
                name: null,
                company_name: null,
                phone: null,
                email: null,
                interest: 'Kancelárska tlač',
                term: this.months[0],
                agree: false,
                token: null
            },
            datePickerLang: {
                formatLocale: {
                    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'],
                    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
                    weekdays: ['Nedeľa', 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
                    weekdaysShort: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
                    weekdaysMin: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
                    firstDayOfWeek: 1,
                }
            }
        }
    },
    mounted() {
        this.form.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    },
    methods: {
        disablePastDates(date) {
            const today = new Date();
            return date < new Date(today.getFullYear(), today.getMonth(), today.getDate());
        },
        
        async send() {
            this.loading = true
            this.errors = []

            if (!this.form.name) {
                this.errors.push('name')
            }

            if (!this.form.company_name) {
                this.errors.push('company_name')
            }

            if (!this.form.phone) {
                this.errors.push('phone')
            }

            if (!this.form.email) {
                this.errors.push('email')
            }

            if (!this.form.interest) {
                this.errors.push('interest')
            }

            if (!this.form.term) {
                this.errors.push('term')
            }

            if (!this.form.agree) {
                this.errors.push('agree')
            }

            if (this.errors.length > 0) {
                this.loading = false
                return true
            }

            setTimeout(async () => {
                await axios.post('/showroom', this.form)

                this.loading = false
                this.posted = true
            }, 300)
        }
    }
}
</script>

<style>
.mx-datepicker {
    @apply w-full;
}
</style>
